import React from 'react'

function Watch() {
  return (
    <div>
    <br/><br/>
    <h1>thes is Watch page</h1>
    </div>
  )
}

export default Watch